export const notifyHandledException = (error: Error, logToConsole = false): void => {
  if (logToConsole) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  window.Sentry?.captureException(error);
};
